module.exports = __webpack_public_path__ + "img/qunhuoma.f9dad0ef.png";